import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-semibold text-foreground-900 whitespace-nowrap">
                韩国漫画网
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              提供免费韩国漫画在线阅读，无遮挡下拉式阅读体验，让您专注于漫画情节本身。每日更新海量优质韩漫资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">
              <a href="#quick-links">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">首页</Link></li>
              <li><Link to="/category/romance" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">奇幻漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">热血漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">
              <a href="#more-categories">更多分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/drama" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">剧情漫画</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">喜剧漫画</Link></li>
              <li><Link to="/category/thriller" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">悬疑漫画</Link></li>
              <li><Link to="/category/daily" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">日常漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">
              <a href="#about-us">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">联系方式</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#weibo" className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center hover:bg-primary-100 transition-colors duration-200" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-foreground-500 text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#wechat" className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center hover:bg-primary-100 transition-colors duration-200" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-foreground-500 text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#bilibili" className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center hover:bg-primary-100 transition-colors duration-200" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line text-foreground-500 text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 韩国漫画网. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#privacy" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors duration-200 whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#terms" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors duration-200 whitespace-nowrap" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}